import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { coreVendors } from '@nexxe/core-vendors';
import { Observable, Subscription } from 'rxjs';
import { CdsMetadata } from '../class/cds-metadata';
import { CDSMetadata } from '../class/CDSMetadata';
import { Status } from '../enums/status';
import { ICDSChange } from '../interfaces/icds';
import { CdsDataComposerService } from './cds-data-composer.service';
import { CdsHttpService } from './cds-http.service';
import { CdsStoreService } from './cds-store.service';
import { CdsUtilitiesService } from './cds-utilities.service';

@Injectable({
	providedIn: 'root'
})
export class CdsRequestService {
	private _channelService;
	public get channelService() {
		return this._channelService;
	}
	public set channelService(value) {
		this._channelService = value;
	}
	constructor(
		private utility: CdsUtilitiesService,
		private injector: Injector,
		private store: CdsStoreService,
		private cdsHttp: CdsHttpService,
		private cdsComposer: CdsDataComposerService
	) {

	}
	/**
		 * 
		 * @param req 
		 * @description creates http subscription and xhr requests
		 */
	execute(req: CDSMetadata): void;

	execute(req: CdsMetadata): void;

	execute(req: any): void {
		//var date = new Date();
		var http = this.cdsHttp.createHttpMethod(req);
		req.status = Status.progress;

		var httpSubscription = http.subscribe((response) => {
			if (response && response.errorCode) this._channelService.send({
				from: "CDS",
				to: [{
					receiverName: 'CDS_ERROR_CODE_RECEIVER',
					acknowledged: false
				}],
				action: 'CDS_ERROR',
				params: {
					response: response
				}
			});
			response = response && response.data ? response.data : response;
			if (req.outputPath) {
				response = coreVendors.lodash.get(response, req.outputPath);
			}
			req.status = Status.success;
			this.utility.updateResponse(req.key, req.id, response);
			this.utility.updateStats(req.key, req.id, (new Date()).getTime());
			this.store.request.next({ patch: { key: req.key, id: req.id }, store: response } as ICDSChange)
			//this.autoInvoke(req);
		},
			(error) => {
				if (error && error.status == 403) {
					let message = this._channelService.createMessage({
						from: "CDS",
						toList: ["ERROR_CODE_RECEIVER"],
						action: '403_ERROR',
						params: { response: error }
					});
					this._channelService.send(message);
				}
				req.status = Status.failed;
				this.store.request.next({ patch: { key: req.key, id: req.id }, store: error } as ICDSChange)
			}, () => {
				httpSubscription.unsubscribe();
			});
	}

	executeMultiple(reqs: Array<CDSMetadata>, keys: Array<string>, ids: Array<string>, responses: Object, pendingResponses: Array<{ obs: Observable<any>, key: string, id: string }>);
	executeMultiple(reqs: Array<CdsMetadata>, keys: Array<string>, ids: Array<string>, responses: Object, pendingResponses: Array<{ obs: Observable<any>, key: string, id: string }>);
	executeMultiple(reqs: Array<any>, keys: Array<string>, ids: Array<string>, responses: Object, pendingResponses: Array<{ obs: Observable<any>, key: string, id: string }>) {
		let http: Observable<any>;
		let count = reqs.length + pendingResponses.length;
		if (count === 0) this.store.request.next({ patch: { key: keys, id: ids }, store: responses } as ICDSChange);
		var httpSubscriptions = new Subscription();
		if (pendingResponses.length) {
			pendingResponses.forEach(pro => httpSubscriptions.add(pro.obs.subscribe((c: { key, id, response }) => {
				responses[pro.key] = this.utility.getExistingResponse(pro.key, pro.id);
				count--;
				if (!count) {
					httpSubscriptions.unsubscribe();
					this.store.request.next({ patch: { key: keys, id: ids }, store: responses } as ICDSChange);
				}
			})))
		}
		coreVendors.lodash.forEach(reqs, (req) => {
			http = this.cdsHttp.createHttpMethod(req)
			req.status = Status.progress
			httpSubscriptions.add(http.subscribe((response) => {
				if (response && response.errorCode) this._channelService.send({
					from: "CDS",
					to: [{
						receiverName: 'WORKSPACE',
						acknowledged: false
					}],
					action: 'CDS_ERROR',
					params: {
						response: response
					}
				});
				response = response && response.data ? response.data : response;
				req.status = Status.success;
				this.utility.updateResponse(req.key, req.id, response);
				this.utility.updateStats(req.key, req.id, (new Date()).getTime());
				responses[req.key] = response;
				count--
				if (!count) {
					httpSubscriptions.unsubscribe();
					this.store.request.next({ patch: { key: keys, id: ids }, store: responses } as ICDSChange);
				}
			},
				(error) => {
					req.status = Status.failed;
					this.store.request.error({ patch: { key: keys, id: ids }, store: error } as ICDSChange);
				}));
		});
	}



}
